<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Reports & Analytics</h2>
      <p class="text-sm text-gray-500 mt-1">View booking hotspots and analytics.</p>
    </div>
    <button
      (click)="loadReports()"
      class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582M20 20v-5h-.581M5.635 19A9 9 0 104.582 9H4" />
      </svg>
      Refresh
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadReports()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && reports">

    <!-- Heatmap Container -->
    <div class="bg-white p-6 rounded-2xl shadow">
      <h3 class="font-semibold text-gray-800 mb-4">Booking Hotspots (Heatmap)</h3>
      
      <!-- Placeholder Map Container -->
      <div class="w-full h-[400px] bg-gray-100 rounded-xl flex items-center justify-center border border-gray-200 relative overflow-hidden">
         <div class="text-center">
            <svg class="w-12 h-12 text-gray-400 mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
               <path stroke-linecap="round" stroke-linejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
            <p class="text-gray-500 font-medium">Map Integration Required</p>
            <p class="text-sm text-gray-400 mt-1">Loaded {{ reports.booking_heatmap.length }} data points.</p>
         </div>
      </div>
    </div>

    <!-- Data Table -->
    <div class="bg-white rounded-2xl shadow overflow-hidden mt-6">
      <table class="w-full text-sm">
        <thead class="bg-gray-100 text-left">
          <tr>
            <th class="p-4">Latitude</th>
            <th>Longitude</th>
            <th>Intensity</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let point of reports.booking_heatmap" class="border-t hover:bg-gray-50">
            <td class="p-4">{{ point.latitude | number:'1.4-4' }}</td>
            <td>{{ point.longitude | number:'1.4-4' }}</td>
            <td>
              <div class="w-full bg-gray-200 rounded-full h-2.5 max-w-[150px]">
                <div class="bg-blue-600 h-2.5 rounded-full" [style.width.%]="point.intensity"></div>
              </div>
            </td>
          </tr>
          <tr *ngIf="reports.booking_heatmap.length === 0">
            <td colspan="3" class="p-8 text-center text-gray-500">No heatmap data available.</td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>

</div>

